import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { MEDIA_APPROVAL_STATUSES } from "media/model"
import { getMediaApprovalStatusColor, getMediaApprovalStatusIcon } from "media/tools/status"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IMediaApprovalStatusProps {
  status: MEDIA_APPROVAL_STATUSES | undefined | null
  id?: string
  uppercase?: boolean
  sx?: any
}

export const MediaApprovalStatus = React.memo(({ status, id, uppercase, sx }: IMediaApprovalStatusProps) => {
  if (!status) {
    return null
  }
  return (
    <FlexBox
      sx={{
        "gap": ".3rem",
        "& .icon": {
          color: getMediaApprovalStatusColor(status),
          width: "1rem !important",
          height: "1rem !important"
        },
        ...sx
      }}>
      <FontAwesomeIcon icon={getMediaApprovalStatusIcon(status)} className="icon" />
      <Typography id={id} color="textPrimary" textTransform={uppercase ? "uppercase" : undefined} fontSize=".8rem">
        {translate(`media.creatives.status.${status}`)}
      </Typography>
    </FlexBox>
  )
})
